/* eslint-disable no-console */
import isObject from '#shared/util/isObject.js';

/**
 * Console logger for WatchingYou module
 * @class WatchingYouConsole
 */
export default class WatchingYouConsole {

	/**
	 * Method called by WatchingYou instance
	 * @param {string} level log,info,warn,error
	 * @param {Date} date Date instance
	 * @param {Array} data
	 * @public
	 * @memberof WatchingYouConsole
	 */
	log(level, date, data) {
		if (isObject(console) && typeof console[level] === 'function') {
			console[level](...data);
		}
	}

}
